module.exports = __webpack_public_path__ + "img/map.22a5fdda.png";